import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { Location } from '../../../../shared/models/v2/search';
import '../../../../core/util/array-prototypes';
import { EmbedSource, getEmbedSource } from 'src/app/core/util/root-element';

@Component({
  selector: 'fal-transportation',
  templateUrl: './transportation.component.html',
  styleUrls: ['./transportation.component.scss']
})
export class TransportationComponent {
  private _location: Location | undefined;
  @Input()
  public get location(): Location | undefined {
    return this._location;
  }
  public set location(value: Location | undefined) {
    if (!value) {
      return;
    }

    this._location = value;
    this.setTransportationInfo(value);
    this.validateTransportDetails();
  }

  loadTransportDetails: Subject<string[]> = new Subject<string[]>();
  isChart = false;
  busRouteDetails: string[] | null;
  parkingDetails: string[] | null;
  directionsDetails: string[] | null;

  showTransportDetails = false;
  showBusRoutesDetails = false;
  showParkingInfoDetails = false;
  showDirectionsDetails = false;
  selectedTransportationDetails?: string[];

  constructor() {
    // intentionally empty
  }

  setTransportationInfo(location: Location): void {
    this.busRouteDetails = location.busRouteInformation;
    this.parkingDetails = location.parkingInformation;
    this.directionsDetails = location.directions;
  }

  validateTransportDetails(): void {
    this.showBusRoutesDetails = Boolean(this.busRouteDetails?.hasValue());
    this.showParkingInfoDetails = Boolean(this.parkingDetails?.hasValue());
    this.showDirectionsDetails = Boolean(this.directionsDetails?.hasValue());

    if (this.showBusRoutesDetails || this.showParkingInfoDetails || this.showDirectionsDetails) {
      this.showTransportDetails = true;
    }
  }

  showModalDetails(selectedTransportationDetails: string[] | null): void {
    if (selectedTransportationDetails != null) this.loadTransportDetails.next(selectedTransportationDetails);
    const embedSource = getEmbedSource();
    if (embedSource === EmbedSource.EPIC_MY_CHART) {
      this.isChart = true;
      const message = {
        fal: true,
        height: document.body.scrollHeight,
        width: document.body.scrollWidth,
        event: 'change-route'
      };
      window?.top?.postMessage(message, '*');
    }
  }
}
